const queryFn = (_, schema, args)=>{
    const [options, client] = args;
    return client(options && 'queryKey' in options ? options.queryKey[0] : schema, {
        parameters: options && 'queryKey' in options ? options.queryKey[1] : options.parameters,
        meta: options.meta,
        signal: options.signal
    });
};

export { queryFn };
//# sourceMappingURL=queryFn.js.map
